import { useRouter } from "next/router";
import { useEffect, useState } from "react";


export default function PageLoadIndicator() {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    router.events.on('routeChangeStart', () => setLoading(true));
    router.events.on('routeChangeComplete', () => setLoading(false));
    router.events.on('routeChangeError', () => setLoading(false));
  }, [router]);

  if (loading) return <div className="fixed top-0 left-0 right-0 h-1 z-50 loading-bar" />

  return null
}